import Steps from './Steps';

export type { IStepsProps } from './Steps.types';
export default Steps;
